import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { HomeInput } from '../../inputs';
import { HomeMediaResponse, HomeBrandsResponse, HomeMediaViewType } from '../../models/common/home-response.model';
import { LanguageService } from '../common/language.service';



@Injectable({
  providedIn: 'root'
})
export class HomeService extends HttpService<
  HomeInput,
  HomeMediaResponse | HomeBrandsResponse | HomeMediaViewType
> {
  languageService = inject(LanguageService);

  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'home'); // 'category' as the base endpoint
  }

  getAllHeroBanners(): Observable<HomeMediaResponse> {
    return this.getBy('?section=carousel') as Observable<HomeMediaResponse>;
  }

  getAllCategoryOffers(): Observable<HomeMediaResponse> {
    return this.getBy('?section=offers') as Observable<HomeMediaResponse>;
  }

  getAllGridBanners(): Observable<HomeMediaResponse> {
    return this.getAll('?section=grid') as Observable<HomeMediaResponse>;
  }

  getAllBrands(): Observable<HomeBrandsResponse> {
    return this.getAll('brands') as Observable<HomeBrandsResponse>;
  }
}
